var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlyingPlane(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 77,
    viewBox: "0 0 82 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1618874567 2",
    clipPath: "url(#clip0_1502_4453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.1356 21.9358L2.49586 39.5095C2.28835 39.7988 2.15437 40.1344 2.10569 40.4873C2.05701 40.8402 2.0949 41.1996 2.21626 41.5344C2.33771 41.8692 2.53867 42.1692 2.80202 42.4084C3.06537 42.6476 3.38301 42.8187 3.72743 42.9068L28.9341 49.3433C28.9341 49.3433 23.09 27.1798 22.722 27.4395C20.066 25.7877 17.5309 23.9484 15.1356 21.9358Z",
    fill: "#AAD2DC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M78.2397 41.4104C66.3288 33.875 27.3869 9.88441 12.6491 0.81561C12.2196 0.551289 11.7192 0.426461 11.2161 0.458168C10.7131 0.489881 10.2319 0.676562 9.83875 0.992737C9.44559 1.30891 9.15949 1.73911 9.01957 2.22444C8.87966 2.70977 8.89267 3.22651 9.05701 3.704L15.1291 21.9349L2.53745 39.446C2.32335 39.7647 2.19663 40.1342 2.17014 40.5174C2.14365 40.9006 2.21834 41.284 2.38656 41.6291C2.6538 42.1959 16.679 33.0754 16.679 33.0754C16.679 33.0754 16.4892 57.0371 16.4263 68.3951C16.4233 69.037 16.5821 69.6693 16.8883 70.2331C17.1945 70.797 17.6379 71.2741 18.1774 71.6199C18.717 71.9659 19.3351 72.1694 19.9743 72.2117C20.6135 72.2539 21.2531 72.1336 21.8335 71.8617L78.0087 45.3866C78.3639 45.2011 78.665 44.9264 78.8826 44.5894C79.1002 44.2524 79.2268 43.8646 79.2501 43.4639C79.2734 43.0633 79.1926 42.6634 79.0155 42.3035C78.8384 41.9435 78.5711 41.6358 78.2397 41.4104Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M2.33971 41.7362C2.60845 42.2812 16.6337 33.1605 16.6337 33.1605L59.177 41.1463C59.2343 41.1595 59.2943 41.1513 59.3459 41.1232C59.3975 41.0951 59.4369 41.049 59.4569 40.9936C59.4769 40.9383 59.4759 40.8775 59.4543 40.8229C59.4327 40.7682 59.3918 40.7233 59.3394 40.6968L15.1334 21.9358L2.54174 39.4469C2.29955 39.7723 2.15239 40.1588 2.11672 40.563C2.08103 40.9673 2.15824 41.3735 2.33971 41.7362Z",
    fill: "#D3E3EB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1502_4453"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 77.1739,
    height: 71,
    fill: "white",
    transform: "matrix(-0.99762 -0.0689572 -0.0689572 0.99762 81.8867 5.32178)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlyingPlane);
export default __webpack_public_path__ + "static/media/flyingPlane.72e8d4c1edb7fc515579d67e8ca5a285.svg";
export { ForwardRef as ReactComponent };